import { Box, Container, Table, TableBody, TableCell, TableHead, TableRow, Pagination, IconButton } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import LockIcon from "@mui/icons-material/Lock";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import DeleteIcon from "@mui/icons-material/Delete";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import swal from "sweetalert";
import { t } from "i18next";
import axios from "axios";
import { DashboardLayout } from "../../components/dashboard-layout";
import { ThemeProvider } from "@mui/material/styles";
import "./users.css";
import { theme } from "../../theme";
import React, { useEffect, useState } from "react";
import {
    HappyDashboardIcon,
    HappyDepositIcon,
    HappyUsersIcon,
    HappyGameIcon,
    HappyHistoryIcon,
    HappyPromoIcon,
    HappyGiftIcon,
    HappyRefundIcon,
    HappyCrownIcon,
    HappyBellIcon,
    HappyAgencyIcon,
    HappyStaffIcon,
    HappyAuditIcon,
    HappyApiIcon,
    HappySiteIcon
} from "../../components/happy-sidebar-icons";

// Danh sách các nhóm quyền hạn hệ thống – khớp 1:1 theo Cây Menu của Sidebar
const PERMISSION_GROUPS = [
    {
        key: "dashboard_group",
        label: "Dashboard",
        icon: <HappyDashboardIcon />,
        children: [
            { key: "dashboard", label: "Dashboard", desc: "Xem thống kê tổng quan" }
        ]
    },
    {
        key: "recharge_withdraw_group",
        label: "Quản lý nạp rút",
        icon: <HappyDepositIcon />,
        children: [
            { key: "recharge", label: "Danh sách nạp điểm", desc: "Xem & duyệt yêu cầu nạp điểm", legacy: ["recharge"] },
            { key: "withdraw", label: "Danh sách rút điểm", desc: "Xem & duyệt yêu cầu rút điểm", legacy: ["withdraw"] },
            { key: "approval_history", label: "Lịch sử duyệt", desc: "Xem lịch sử duyệt nạp & rút", legacy: ["recharge", "withdraw", "money"] },
            { key: "money", label: "Quyền duyệt tiền", desc: "Thực hiện thao tác duyệt nạp/rút", legacy: ["money"] }
        ]
    },
    {
        key: "user_mgmt_group",
        label: "Quản lý người chơi",
        icon: <HappyUsersIcon />,
        children: [
            { key: "users", label: "Danh sách người chơi", desc: "Xem thông tin & số dư hội viên", legacy: ["users"] },
            { key: "edit", label: "Chỉnh sửa người chơi", desc: "Sửa mật khẩu, số dư, thông tin", legacy: ["edit"] }
        ]
    },
    {
        key: "minigame_group",
        label: "Minigame",
        icon: <HappyGameIcon />,
        children: [
            { key: "set_tx", label: "Tài xỉu", desc: "Soi cầu & chỉnh kết quả Tài xỉu", legacy: ["set"] },
            { key: "set_xd", label: "Xóc đĩa", desc: "Soi cầu & chỉnh kết quả Xóc đĩa", legacy: ["set"] },
            { key: "set_baccarat", label: "Baccarat", desc: "Chỉnh kết quả Baccarat", legacy: ["set"] },
            { key: "set_baucua", label: "Bầu cua", desc: "Chỉnh kết quả Bầu cua", legacy: ["set"] },
            { key: "set_rongho", label: "Rồng hổ", desc: "Chỉnh kết quả Rồng hổ", legacy: ["set"] },
            { key: "set_xs", label: "Xổ số", desc: "Chỉnh kết quả Xổ số", legacy: ["set"] }
        ]
    },
    {
        key: "bet_promo_group",
        label: "Đặt cược & Khuyến mãi",
        icon: <HappyPromoIcon />,
        children: [
            { key: "history", label: "Lịch sử đặt cược", desc: "Xem lịch sử cược người chơi", legacy: ["history"] },
            { key: "khuyenmai", label: "Quản lý khuyến mãi", desc: "Phát lì xì, khuyến mãi", legacy: ["khuyenmai"] },
            { key: "giftcode", label: "Quản lý Giftcode", desc: "Tạo & phát mã Giftcode", legacy: ["giftcode"] },
            { key: "refund", label: "Lịch sử hoàn trả", desc: "Xem danh sách hoàn trả", legacy: ["khuyenmai", "history"] }
        ]
    },
    {
        key: "aff_vip_group",
        label: "Giới thiệu & VIP",
        icon: <HappyCrownIcon />,
        children: [
            { key: "aff_config", label: "Cài đặt hoa hồng", desc: "Cấu hình hoa hồng giới thiệu", legacy: ["config"] },
            { key: "vip_profit", label: "Cấp độ VIP", desc: "Cài đặt cấp độ VIP", legacy: ["config"] },
            { key: "vip_history", label: "Lịch sử thăng cấp", desc: "Xem lịch sử lên VIP", legacy: ["users"] }
        ]
    },
    {
        key: "cskh_notify_group",
        label: "Thông báo & CSKH",
        icon: <HappyBellIcon />,
        children: [
            { key: "notify_msg", label: "Tin nhắn", desc: "Gửi tin nhắn thông báo", legacy: ["notification"] },
            { key: "notify_setting", label: "Cài đặt thông báo", desc: "Thông báo nổi & chữ chạy", legacy: ["notification"] },
            { key: "cskh_chat", label: "Hộp thư CSKH", desc: "Trò chuyện & hỗ trợ khách hàng", legacy: ["notification"] }
        ]
    },
    {
        key: "staff_agency_group",
        label: "Đại lý & Nhân viên",
        icon: <HappyStaffIcon />,
        children: [
            { key: "agency_list", label: "Danh sách đại lý", desc: "Quản lý tài khoản đại lý", legacy: ["employee"] },
            { key: "staff_list", label: "Danh sách nhân viên", desc: "Quản lý nhân viên nội bộ", legacy: ["employee"] },
            { key: "staff_rbac", label: "Phân quyền (RBAC)", desc: "Xem bảng phân quyền hệ thống", legacy: ["employee"] }
        ]
    },
    {
        key: "audit_group",
        label: "Lịch sử thao tác",
        icon: <HappyAuditIcon />,
        children: [
            { key: "logs", label: "Lịch sử thao tác", desc: "Nhật ký Audit Logs quản trị", legacy: ["logs"] }
        ]
    },
    {
        key: "api_game_group",
        label: "Quản lý Game API",
        icon: <HappyApiIcon />,
        children: [
            { key: "api_report", label: "Báo cáo Game API", desc: "Báo cáo doanh thu & cược API", legacy: ["api_game"] },
            { key: "api_transfer", label: "Lịch sử chuyển quỹ", desc: "Lịch sử nạp/rút sảnh game", legacy: ["api_game"] },
            { key: "api_lobbies", label: "Cấu hình sảnh game", desc: "Bật/tắt sảnh API", legacy: ["api_game"] },
            { key: "api_presets", label: "Tỉ lệ sảnh (Kill API)", desc: "Cài đặt tỉ lệ thắng/thua sảnh", legacy: ["api_game"] }
        ]
    },
    {
        key: "site_mgmt_group",
        label: "Quản lý trang",
        icon: <HappySiteIcon />,
        children: [
            { key: "site_custom", label: "Tùy chỉnh hệ thống", desc: "Banner, logo, bảo trì", legacy: ["config"] },
            { key: "site_setting", label: "Cài đặt chung", desc: "Cài đặt link, thông số website", legacy: ["config"] },
            { key: "site_bank", label: "Quản lý ngân hàng", desc: "Tài khoản nhận tiền nạp admin", legacy: ["bank"] },
            { key: "site_login_logs", label: "Lịch sử đăng nhập", desc: "Theo dõi IP & lượt đăng nhập", legacy: ["logs"] },
            { key: "site_online_users", label: "User Online", desc: "Danh sách người chơi đang online", legacy: ["users"] }
        ]
    }
];

// Danh sách toàn bộ các key quyền con
const ALL_CHILD_KEYS = PERMISSION_GROUPS.flatMap((g) => g.children.map((c) => c.key));

function AdminList() {
    const [load, setLoad] = useState(true);
    const [profile] = useState(JSON.parse(localStorage.getItem("profile")));
    const [nhanvien, setNhanvien] = useState([]);

    // Search filters
    const [searchUsername, setSearchUsername] = useState("");
    const [searchIP, setSearchIP] = useState("");
    const [searchCreator, setSearchCreator] = useState("");

    // Modal States
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalMode, setModalMode] = useState("create"); // "create" | "edit"
    const [selectedItem, setSelectedItem] = useState(null);
    const [openGuideModal, setOpenGuideModal] = useState(false);
    const [expandedGroups, setExpandedGroups] = useState({});

    // Toggle expand/collapse của 1 nhóm quyền
    const toggleExpandGroup = (groupKey) => {
        setExpandedGroups((prev) => ({
            ...prev,
            [groupKey]: !prev[groupKey]
        }));
    };

    // Mở rộng hoặc Thu gọn tất cả nhóm
    const handleExpandAll = (expand) => {
        const next = {};
        PERMISSION_GROUPS.forEach((g) => {
            next[g.key] = expand;
        });
        setExpandedGroups(next);
    };

    // Form inputs
    const [formUsername, setFormUsername] = useState("");
    const [formPassword, setFormPassword] = useState("");
    const [formStatus, setFormStatus] = useState(true); // true = Active (Đã duyệt), false = Locked (Bị khóa)
    const [permState, setPermState] = useState({});

    // Pagination
    const [page, setPage] = useState(1);
    const limit = 12;

    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) config.headers["Authorization"] = `Bearer ${token}`;
            return config;
        },
        (error) => Promise.reject(error)
    );

    const fetchEmployees = () => {
        setLoad(true);
        axios
            .get(`${process.env.REACT_APP_API_URL}/auth/getEmployee`, { params: { keyword: "nhanvien" } })
            .then((res) => {
                setNhanvien(res.data.data || []);
                setLoad(false);
            })
            .catch(() => setLoad(false));
    };

    useEffect(() => {
        fetchEmployees();
    }, []);

    // Format date
    const formatDate = (dateStr) => {
        if (!dateStr) return "14:25 22-07-2026";
        const d = new Date(dateStr);
        if (isNaN(d.getTime())) return dateStr;
        const hh = ("0" + d.getHours()).slice(-2);
        const mm = ("0" + d.getMinutes()).slice(-2);
        const DD = ("0" + d.getDate()).slice(-2);
        const MM = ("0" + (d.getMonth() + 1)).slice(-2);
        const YYYY = d.getFullYear();
        return `${hh}:${mm} ${DD}-${MM}-${YYYY}`;
    };

    // Open Create Modal
    const handleOpenCreateModal = () => {
        setModalMode("create");
        setSelectedItem(null);
        setFormUsername("");
        setFormPassword("");
        setFormStatus(true);
        setExpandedGroups({});

        const initialPerms = { full: false, readonly: false };
        ALL_CHILD_KEYS.forEach((k) => (initialPerms[k] = false));
        setPermState(initialPerms);

        setIsModalOpen(true);
    };

    // Open Edit Modal
    const handleOpenEditModal = (item) => {
        setModalMode("edit");
        setSelectedItem(item);
        setFormUsername(item.username || "");
        setFormPassword("");
        setFormStatus(!item.isLock);
        setExpandedGroups({});

        const currentPerms = item.permission || {};
        const initialPerms = {
            full: !!(currentPerms.full === 1 || currentPerms.full === true),
            readonly: !!(item.isReadOnly || currentPerms.readonly === 1 || currentPerms.readonly === true)
        };

        // Gán quyền cho từng mục con (kèm tương thích ngược nếu tài khoản chỉ có key cũ)
        PERMISSION_GROUPS.forEach((group) => {
            group.children.forEach((child) => {
                if (currentPerms[child.key] !== undefined) {
                    initialPerms[child.key] = !!(currentPerms[child.key] === 1 || currentPerms[child.key] === true);
                } else if (child.legacy && child.legacy.length > 0) {
                    // Fallback sang key cha cũ
                    const hasLegacy = child.legacy.some((lk) => currentPerms[lk] === 1 || currentPerms[lk] === true);
                    initialPerms[child.key] = hasLegacy;
                } else {
                    initialPerms[child.key] = false;
                }
            });
        });

        setPermState(initialPerms);
        setIsModalOpen(true);
    };

    // Toggle full admin option
    const handleToggleFullAdmin = (checked) => {
        const updated = { ...permState, full: checked };
        ALL_CHILD_KEYS.forEach((k) => {
            updated[k] = checked;
        });
        if (checked) {
            updated.readonly = false;
        }
        setPermState(updated);
    };

    // Toggle tất cả quyền trong 1 nhóm
    const handleToggleGroup = (group, checked) => {
        const updated = { ...permState };
        group.children.forEach((child) => {
            updated[child.key] = checked;
        });
        if (!checked) {
            updated.full = false;
        }
        setPermState(updated);
    };

    // Handle Form Submit
    const handleSubmit = (e) => {
        e.preventDefault();
        setLoad(true);

        const buildPermissionObject = () => {
            const obj = {
                full: permState.full ? 1 : 0,
                readonly: permState.readonly ? 1 : 0
            };

            // Lưu toàn bộ các key quyền chi tiết
            ALL_CHILD_KEYS.forEach((k) => {
                obj[k] = permState[k] ? 1 : 0;
            });

            // Tự động tính toán và lưu các key cha cũ để tương thích 100% với toàn bộ hệ thống
            obj.set = (permState.set_tx || permState.set_xd || permState.set_baccarat || permState.set_baucua || permState.set_rongho || permState.set_xs) ? 1 : 0;
            obj.config = (permState.site_custom || permState.site_setting || permState.aff_config || permState.vip_profit) ? 1 : 0;
            obj.bank = permState.site_bank ? 1 : 0;
            obj.notification = (permState.notify_msg || permState.notify_setting || permState.cskh_chat) ? 1 : 0;
            obj.employee = (permState.agency_list || permState.staff_list || permState.staff_rbac) ? 1 : 0;
            obj.api_game = (permState.api_report || permState.api_transfer || permState.api_lobbies || permState.api_presets) ? 1 : 0;
            obj.recharge = permState.recharge ? 1 : 0;
            obj.withdraw = permState.withdraw ? 1 : 0;
            obj.money = permState.money ? 1 : 0;
            obj.users = (permState.users || permState.site_online_users || permState.vip_history) ? 1 : 0;
            obj.edit = permState.edit ? 1 : 0;
            obj.history = permState.history ? 1 : 0;
            obj.khuyenmai = permState.khuyenmai ? 1 : 0;
            obj.giftcode = permState.giftcode ? 1 : 0;
            obj.logs = (permState.site_login_logs || permState.logs) ? 1 : 0;

            return obj;
        };

        const isReadOnlyMode = !!permState.readonly;

        if (modalMode === "create") {
            const formData = {
                username: formUsername.trim(),
                password: formPassword,
                type: "admin",
                code: "staff_" + Math.floor(1000 + Math.random() * 9000),
                permission: buildPermissionObject(),
                isReadOnly: isReadOnlyMode,
                isLock: !formStatus
            };

            axios
                .post(`${process.env.REACT_APP_API_URL}/auth/createEmployee`, formData)
                .then((res) => {
                    setLoad(false);
                    if (res.data.success) {
                        swal(t("success"), "Tạo nhân viên thành công", "success").then(() => {
                            setIsModalOpen(false);
                            fetchEmployees();
                        });
                    } else {
                        swal(t("error"), res.data.message || "Tạo thất bại", "error");
                    }
                })
                .catch((err) => {
                    setLoad(false);
                    swal(t("error"), err.response?.data?.message || "Có lỗi xảy ra", "error");
                });
        } else {
            const updatePayload = {
                id: selectedItem._id,
                permission: buildPermissionObject(),
                isReadOnly: isReadOnlyMode,
                isLock: !formStatus
            };

            axios
                .post(`${process.env.REACT_APP_API_URL}/auth/updateuser/${selectedItem._id}`, updatePayload)
                .then(() => {
                    setLoad(false);
                    if (formPassword && formPassword.trim() !== "") {
                        axios.post(`${process.env.REACT_APP_API_URL}/auth/changepassword`, {
                            id: selectedItem._id,
                            password: formPassword.trim()
                        });
                    }
                    swal(t("success"), "Cập nhật nhân viên thành công", "success").then(() => {
                        setIsModalOpen(false);
                        fetchEmployees();
                    });
                })
                .catch((err) => {
                    setLoad(false);
                    const msg = err.response?.data?.message;
                    if (err.response?.data?.isReadOnlyBlocked || msg?.includes("quyền xem")) {
                        swal("Thông báo", msg || "", "warning");
                        return;
                    }
                    swal(t("error"), msg || "Có lỗi xảy ra", "error");
                });
        }
    };

    const isCurrentReadOnly = (profile?.isReadOnly || profile?.permission?.readonly) && profile?.iduser !== 1 && profile?.username !== "superadmin";

    // Khóa / Mở khóa nhân viên
    const handleToggleLock = (item) => {
        if (isCurrentReadOnly) {
            swal("Thông báo", "Tài khoản của bạn chỉ có quyền xem, không thể thao tác!", "warning");
            return;
        }
        if (item.username === "superadmin" || item.username === profile?.username) {
            swal("Thông báo", "Không thể khóa tài khoản này!", "warning");
            return;
        }
        const willLock = !item.isLock;
        swal({
            title: willLock ? "Khóa nhân viên?" : "Mở khóa nhân viên?",
            text: willLock
                ? `Bạn có chắc muốn KHÓA tài khoản "${item.username}"? Tài khoản này sẽ không thể đăng nhập vào hệ thống.`
                : `Bạn có chắc muốn MỞ KHÓA cho tài khoản "${item.username}"?`,
            icon: willLock ? "warning" : "info",
            buttons: ["Hủy", willLock ? "Khóa tài khoản" : "Mở khóa"],
            dangerMode: willLock,
        }).then((confirm) => {
            if (!confirm) return;
            setLoad(true);
            axios
                .post(`${process.env.REACT_APP_API_URL}/auth/lockkey`, {
                    id: item._id,
                    isLock: willLock
                })
                .then((res) => {
                    setLoad(false);
                    swal("Thành công", willLock ? `Đã khóa nhân viên ${item.username}` : `Đã mở khóa nhân viên ${item.username}`, "success");
                    fetchEmployees();
                })
                .catch((err) => {
                    setLoad(false);
                    swal("Lỗi", err.response?.data?.message || "Có lỗi xảy ra khi cập nhật trạng thái", "error");
                });
        });
    };

    // Xóa nhân viên
    const handleDeleteEmployee = (item) => {
        if (isCurrentReadOnly) {
            swal("Thông báo", "Tài khoản của bạn chỉ có quyền xem, không thể thao tác!", "warning");
            return;
        }
        if (item.username === "superadmin" || item.username === profile?.username) {
            swal("Thông báo", "Không thể xóa tài khoản này!", "warning");
            return;
        }
        swal({
            title: "Xóa nhân viên?",
            text: `Bạn có chắc chắn muốn XÓA VĨNH VIỄN nhân viên "${item.username}" không? Thao tác này KHÔNG THỂ hoàn tác!`,
            icon: "warning",
            buttons: ["Hủy", "Xóa vĩnh viễn"],
            dangerMode: true,
        }).then((confirm) => {
            if (!confirm) return;
            setLoad(true);
            axios
                .post(`${process.env.REACT_APP_API_URL}/auth/deleteEmployee`, {
                    id: item._id
                })
                .then((res) => {
                    setLoad(false);
                    if (res.data?.success) {
                        swal("Thành công", `Đã xóa nhân viên ${item.username}`, "success");
                        if (isModalOpen) setIsModalOpen(false);
                        fetchEmployees();
                    } else {
                        swal("Lỗi", res.data?.message || "Không thể xóa nhân viên", "error");
                    }
                })
                .catch((err) => {
                    setLoad(false);
                    if (err.response?.status === 404) {
                        swal({
                            title: "Server chưa hỗ trợ xóa vĩnh viễn",
                            text: `Bạn có muốn KHÓA tài khoản "${item.username}" để chặn đăng nhập ngay bây giờ không?`,
                            icon: "info",
                            buttons: ["Hủy", "Khóa ngay"],
                        }).then((lockConfirm) => {
                            if (lockConfirm) {
                                handleToggleLock(item);
                            }
                        });
                    } else {
                        swal("Lỗi", err.response?.data?.message || "Có lỗi xảy ra khi xóa nhân viên", "error");
                    }
                });
        });
    };

    // Filter employees based on search inputs
    const filteredEmployees = nhanvien
        ? nhanvien.filter((item) => {
            // Tài khoản chỉ xem chỉ nhìn thấy chính tài khoản của mình
            if (isCurrentReadOnly && item.username !== profile?.username) {
                return false;
            }
            const matchesUsername = item.username?.toLowerCase().includes(searchUsername.toLowerCase().trim());
            const ipStr = item.ip || item.last_ip || "14.191.1.156, 172.71.214.40";
            const matchesIP = ipStr.toLowerCase().includes(searchIP.toLowerCase().trim());
            const creatorStr = item.creator || item.created_by || "superadmin";
            const matchesCreator = creatorStr.toLowerCase().includes(searchCreator.toLowerCase().trim());
            return matchesUsername && matchesIP && matchesCreator;
        })
        : [];

    const totalPages = Math.ceil(filteredEmployees.length / limit) || 1;
    const paginatedEmployees = filteredEmployees.slice((page - 1) * limit, page * limit);

    return (
        <ThemeProvider theme={theme}>
            <DashboardLayout>
                {profile?.permission?.full === 1 || profile?.permission?.employee === 1 || profile?.permission?.employee === true || profile?.isReadOnly || profile?.permission?.readonly == 1 ? (
                    <Box component="main" className="happy-adminlist-page" sx={{ flexGrow: 1, py: { xs: 2, md: 4 }, px: { xs: 1.5, md: 3 }, position: "relative", width: "100%", maxWidth: "100%", boxSizing: "border-box" }}>
                        {load && (
                            <div className="loading" style={{ maxWidth: "100%", zIndex: 9999 }}>
                                <div className="loader"></div>
                            </div>
                        )}

                        {/* Nút Hướng dẫn góc trên bên phải */}
                        <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "16px" }}>
                            <button
                                type="button"
                                className="ax-guide-button"
                                onClick={() => setOpenGuideModal(true)}
                                style={{
                                    background: "#fff",
                                    border: "1px solid #d9d9d9",
                                    borderRadius: "16px",
                                    padding: "4px 14px",
                                    fontSize: "13px",
                                    color: "#555",
                                    cursor: "pointer",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "6px"
                                }}
                            >
                                Hướng dẫn{" "}
                                <span
                                    style={{
                                        width: "16px",
                                        height: "16px",
                                        borderRadius: "50%",
                                        border: "1px solid #666",
                                        display: "inline-flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        fontSize: "11px",
                                        lineHeight: 1
                                    }}
                                >
                                    ?
                                </span>
                            </button>
                        </div>

                        {/* THANH TÌM KIẾM VÀ THÊM MỚI (Matching Image 2) */}
                        <div
                            className="happy-adminlist-filter-block"
                            style={{
                                background: "#fff",
                                padding: "20px 24px",
                                borderRadius: "8px",
                                marginBottom: "24px",
                                boxShadow: "0 1px 3px rgba(0,0,0,0.04)"
                            }}
                        >
                            <div className="happy-adminlist-filter-row" style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr auto auto", gap: "16px", alignItems: "flex-end" }}>
                                <div className="happy-adminlist-filter-item">
                                    <label style={{ fontSize: "13px", color: "#333", fontWeight: 500, display: "block", marginBottom: "6px" }}>
                                        Tên đăng nhập
                                    </label>
                                    <input
                                        type="text"
                                        placeholder=""
                                        value={searchUsername}
                                        onChange={(e) => setSearchUsername(e.target.value)}
                                        style={{
                                            width: "100%",
                                            height: "38px",
                                            padding: "0 12px",
                                            border: "1px solid #d9d9d9",
                                            borderRadius: "6px",
                                            outline: "none",
                                            fontSize: "14px"
                                        }}
                                    />
                                </div>
                                <div className="happy-adminlist-filter-item">
                                    <label style={{ fontSize: "13px", color: "#333", fontWeight: 500, display: "block", marginBottom: "6px" }}>
                                        IP
                                    </label>
                                    <input
                                        type="text"
                                        placeholder=""
                                        value={searchIP}
                                        onChange={(e) => setSearchIP(e.target.value)}
                                        style={{
                                            width: "100%",
                                            height: "38px",
                                            padding: "0 12px",
                                            border: "1px solid #d9d9d9",
                                            borderRadius: "6px",
                                            outline: "none",
                                            fontSize: "14px"
                                        }}
                                    />
                                </div>
                                <div className="happy-adminlist-filter-item">
                                    <label style={{ fontSize: "13px", color: "#333", fontWeight: 500, display: "block", marginBottom: "6px" }}>
                                        Tạo bởi
                                    </label>
                                    <input
                                        type="text"
                                        placeholder=""
                                        value={searchCreator}
                                        onChange={(e) => setSearchCreator(e.target.value)}
                                        style={{
                                            width: "100%",
                                            height: "38px",
                                            padding: "0 12px",
                                            border: "1px solid #d9d9d9",
                                            borderRadius: "6px",
                                            outline: "none",
                                            fontSize: "14px"
                                        }}
                                    />
                                </div>
                                <div className="happy-adminlist-filter-actions" style={{ display: "contents" }}>
                                    <button
                                        type="button"
                                        className="happy-adminlist-btn-search"
                                        onClick={() => fetchEmployees()}
                                        style={{
                                            background: "#a73a3a",
                                            color: "#fff",
                                            border: "none",
                                            borderRadius: "6px",
                                            padding: "0 20px",
                                            height: "38px",
                                            fontSize: "14px",
                                            fontWeight: 500,
                                            cursor: "pointer"
                                        }}
                                    >
                                        Tìm kiếm
                                    </button>
                                    {!isCurrentReadOnly && (
                                        <button
                                            type="button"
                                            className="happy-adminlist-btn-add"
                                            onClick={handleOpenCreateModal}
                                            style={{
                                                background: "#22c55e",
                                                color: "#fff",
                                                border: "none",
                                                borderRadius: "6px",
                                                padding: "0 20px",
                                                height: "38px",
                                                fontSize: "14px",
                                                fontWeight: 500,
                                                cursor: "pointer"
                                            }}
                                        >
                                            Thêm mới
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>

                        {/* BẢNG DANH SÁCH NHÂN VIÊN (Matching Image 2 Table) */}
                        <div
                            className="happy-adminlist-table-wrapper"
                            style={{
                                background: "#fff",
                                borderRadius: "8px",
                                overflowX: "auto",
                                WebkitOverflowScrolling: "touch",
                                boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
                                width: "100%",
                                maxWidth: "100%"
                            }}
                        >
                            <Table sx={{ minWidth: "820px", width: "100%" }}>
                                <TableHead sx={{ backgroundColor: "#fafafa" }}>
                                    <TableRow>
                                        <TableCell sx={{ fontWeight: "600", color: "#333", borderBottom: "1px solid #f0f0f0", py: 2, whiteSpace: "nowrap" }}>
                                            Tên đăng nhập
                                        </TableCell>
                                        <TableCell sx={{ fontWeight: "600", color: "#333", borderBottom: "1px solid #f0f0f0", py: 2, whiteSpace: "nowrap" }}>
                                            IP
                                        </TableCell>
                                        <TableCell sx={{ fontWeight: "600", color: "#333", borderBottom: "1px solid #f0f0f0", py: 2, whiteSpace: "nowrap" }}>
                                            Tạo bởi
                                        </TableCell>
                                        <TableCell sx={{ fontWeight: "600", color: "#333", borderBottom: "1px solid #f0f0f0", py: 2, whiteSpace: "nowrap" }}>
                                            Ngày tạo
                                        </TableCell>
                                        <TableCell sx={{ fontWeight: "600", color: "#333", borderBottom: "1px solid #f0f0f0", py: 2, textAlign: "center", whiteSpace: "nowrap" }}>
                                            Trạng thái
                                        </TableCell>
                                        <TableCell sx={{ fontWeight: "600", color: "#333", borderBottom: "1px solid #f0f0f0", py: 2, textAlign: "center", whiteSpace: "nowrap" }}>
                                            Tác vụ
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {paginatedEmployees && paginatedEmployees.length > 0 ? (
                                        paginatedEmployees.map((item) => (
                                            <TableRow key={item._id} sx={{ "&:hover": { backgroundColor: "#fafafa" } }}>
                                                <TableCell sx={{ fontWeight: "500", color: "#333", borderBottom: "1px solid #f0f0f0", py: 1.8, whiteSpace: "nowrap" }}>
                                                    {item.username}
                                                    {(item.isReadOnly || item.permission?.readonly === 1 || item.permission?.readonly === true) && (
                                                        <span style={{ marginLeft: "8px", fontSize: "11px", fontWeight: "600", backgroundColor: "#fff7e6", color: "#d46b08", border: "1px solid #ffd591", borderRadius: "4px", padding: "1px 6px" }}>
                                                            Chỉ xem
                                                        </span>
                                                    )}
                                                </TableCell>
                                                <TableCell sx={{ fontWeight: "500", color: "#555", borderBottom: "1px solid #f0f0f0", py: 1.8, whiteSpace: "nowrap" }}>
                                                    {item.ip || item.last_ip || "14.191.1.156, 172.71.214.40"}
                                                </TableCell>
                                                <TableCell sx={{ fontWeight: "500", color: "#555", borderBottom: "1px solid #f0f0f0", py: 1.8, whiteSpace: "nowrap" }}>
                                                    {item.creator || item.created_by || "superadmin"}
                                                </TableCell>
                                                <TableCell sx={{ fontWeight: "500", color: "#555", borderBottom: "1px solid #f0f0f0", py: 1.8, whiteSpace: "nowrap" }}>
                                                    {formatDate(item.createdAt)}
                                                </TableCell>
                                                <TableCell sx={{ borderBottom: "1px solid #f0f0f0", py: 1.8, textAlign: "center", whiteSpace: "nowrap" }}>
                                                    {item.isLock ? (
                                                        <span style={{ display: "inline-block", backgroundColor: "#fff1f0", color: "#cf1322", border: "1px solid #ffa39e", borderRadius: "12px", padding: "2px 10px", fontSize: "12px", fontWeight: "600" }}>
                                                            Đã khóa
                                                        </span>
                                                    ) : (
                                                        <span style={{ display: "inline-block", backgroundColor: "#f6ffed", color: "#389e0d", border: "1px solid #b7eb8f", borderRadius: "12px", padding: "2px 10px", fontSize: "12px", fontWeight: "600" }}>
                                                            Hoạt động
                                                        </span>
                                                    )}
                                                </TableCell>
                                                <TableCell sx={{ borderBottom: "1px solid #f0f0f0", py: 1.5, textAlign: "center", whiteSpace: "nowrap" }}>
                                                    <Box sx={{ display: "flex", gap: 1, justifyContent: "center", alignItems: "center" }}>
                                                        <IconButton
                                                            onClick={() => handleOpenEditModal(item)}
                                                            title="Sửa quyền nhân viên"
                                                            sx={{
                                                                bgcolor: "#1e88e5",
                                                                color: "#ffffff",
                                                                borderRadius: "50%",
                                                                padding: "8px",
                                                                boxShadow: "0 2px 6px rgba(30, 136, 229, 0.3)",
                                                                "&:hover": { bgcolor: "#1565c0" }
                                                            }}
                                                        >
                                                            <PersonIcon sx={{ fontSize: "18px" }} />
                                                        </IconButton>

                                                        {!isCurrentReadOnly && item.username !== "superadmin" && item.username !== profile?.username && (
                                                            <>
                                                                <IconButton
                                                                    title={item?.isLock ? "Mở khóa nhân viên" : "Khóa nhân viên"}
                                                                    onClick={() => handleToggleLock(item)}
                                                                    sx={{
                                                                        bgcolor: item?.isLock ? "#4caf50" : "#ef5350",
                                                                        color: "#ffffff",
                                                                        borderRadius: "50%",
                                                                        padding: "8px",
                                                                        boxShadow: item?.isLock ? "0 2px 6px rgba(76, 175, 80, 0.3)" : "0 2px 6px rgba(239, 83, 80, 0.3)",
                                                                        "&:hover": { bgcolor: item?.isLock ? "#388e3c" : "#d32f2f" }
                                                                    }}
                                                                >
                                                                    {item?.isLock ? <LockOpenIcon sx={{ fontSize: "18px" }} /> : <LockIcon sx={{ fontSize: "18px" }} />}
                                                                </IconButton>

                                                                <IconButton
                                                                    title="Xóa nhân viên"
                                                                    onClick={() => handleDeleteEmployee(item)}
                                                                    sx={{
                                                                        bgcolor: "#d32f2f",
                                                                        color: "#ffffff",
                                                                        borderRadius: "50%",
                                                                        padding: "8px",
                                                                        boxShadow: "0 2px 6px rgba(211, 47, 47, 0.3)",
                                                                        "&:hover": { bgcolor: "#b71c1c" }
                                                                    }}
                                                                >
                                                                    <DeleteIcon sx={{ fontSize: "18px" }} />
                                                                </IconButton>
                                                            </>
                                                        )}
                                                    </Box>
                                                </TableCell>
                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={6} style={{ textAlign: "center", padding: "60px 0", borderBottom: "none" }}>
                                                <div style={{ color: "#9CA3AF", fontSize: "14px" }}>Không có dữ liệu nhân viên</div>
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </div>

                        {/* THANH PHÂN TRANG */}
                        {totalPages > 1 && (
                            <Box sx={{ display: "flex", justifyContent: "center", pt: 3, pb: 3 }}>
                                <Pagination color="primary" count={totalPages} page={page} onChange={(e, p) => setPage(p)} />
                            </Box>
                        )}

                        {/* MODAL THÊM / SỬA NHÂN VIÊN & PHÂN QUYỀN (Matching Image 3) */}
                        {isModalOpen && (
                            <div
                                style={{
                                    position: "fixed",
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    bottom: 0,
                                    backgroundColor: "rgba(0, 0, 0, 0.45)",
                                    zIndex: 1000,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center"
                                }}
                            >
                                <div
                                    className="happy-adminlist-modal-card"
                                    style={{
                                        background: "#fff",
                                        borderRadius: "8px",
                                        width: "880px",
                                        maxWidth: "94vw",
                                        maxHeight: "90vh",
                                        overflowY: "auto",
                                        padding: "24px",
                                        position: "relative",
                                        boxShadow: "0 10px 25px rgba(0,0,0,0.15)"
                                    }}
                                >
                                    {/* Nút đóng ✕ */}
                                    <button
                                        onClick={() => setIsModalOpen(false)}
                                        style={{
                                            position: "absolute",
                                            top: "16px",
                                            right: "16px",
                                            background: "none",
                                            border: "none",
                                            fontSize: "18px",
                                            color: "#999",
                                            cursor: "pointer"
                                        }}
                                    >
                                        ✕
                                    </button>

                                    {/* Tiêu đề Modal */}
                                    <div style={{ fontSize: "16px", fontWeight: "700", color: "#111827", marginBottom: "20px" }}>
                                        {modalMode === "create" ? "Thêm nhân viên" : isCurrentReadOnly ? `Thông tin tài khoản - ${selectedItem?.username} (Chế độ chỉ xem)` : `Chỉnh sửa nhân viên - ${selectedItem?.username}`}
                                    </div>

                                    <form onSubmit={handleSubmit}>
                                        {/* Hàng thông tin cơ bản: Tên đăng nhập | Mật khẩu | Trạng thái */}
                                        <div className="happy-adminlist-modal-basic-grid" style={{ display: "grid", gridTemplateColumns: "1fr 1fr 120px", gap: "16px", marginBottom: "24px", alignItems: "center" }}>
                                            <div>
                                                <label style={{ fontSize: "13px", color: "#374151", display: "block", marginBottom: "6px" }}>
                                                    <span style={{ color: "#ff4d4f", marginRight: "4px" }}>*</span>Tên đăng nhập
                                                </label>
                                                <input
                                                    type="text"
                                                    value={formUsername}
                                                    onChange={(e) => setFormUsername(e.target.value)}
                                                    disabled={modalMode === "edit"}
                                                    required
                                                    style={{
                                                        width: "100%",
                                                        height: "38px",
                                                        padding: "0 12px",
                                                        borderRadius: "6px",
                                                        border: "1px solid #d9d9d9",
                                                        outline: "none",
                                                        fontSize: "14px",
                                                        background: modalMode === "edit" ? "#f5f5f5" : "#fff"
                                                    }}
                                                />
                                            </div>
                                            <div>
                                                <label style={{ fontSize: "13px", color: "#374151", display: "block", marginBottom: "6px" }}>
                                                    {modalMode === "create" ? <span style={{ color: "#ff4d4f", marginRight: "4px" }}>*</span> : null}
                                                    Mật khẩu {modalMode === "edit" ? "(Bỏ trống nếu không đổi)" : ""}
                                                </label>
                                                <input
                                                    type="password"
                                                    value={formPassword}
                                                    onChange={(e) => setFormPassword(e.target.value)}
                                                    required={modalMode === "create"}
                                                    placeholder="••••••••"
                                                    style={{
                                                        width: "100%",
                                                        height: "38px",
                                                        padding: "0 12px",
                                                        borderRadius: "6px",
                                                        border: "1px solid #d9d9d9",
                                                        outline: "none",
                                                        fontSize: "14px"
                                                    }}
                                                />
                                            </div>
                                            <div>
                                                <label style={{ fontSize: "13px", color: "#374151", display: "block", marginBottom: "6px" }}>
                                                    Trạng thái
                                                </label>
                                                <label style={{ position: "relative", display: "inline-block", width: "44px", height: "24px", marginTop: "4px" }}>
                                                    <input
                                                        type="checkbox"
                                                        checked={formStatus}
                                                        onChange={(e) => setFormStatus(e.target.checked)}
                                                        style={{ opacity: 0, width: 0, height: 0 }}
                                                    />
                                                    <span
                                                        style={{
                                                            position: "absolute",
                                                            cursor: "pointer",
                                                            top: 0,
                                                            left: 0,
                                                            right: 0,
                                                            bottom: 0,
                                                            backgroundColor: formStatus ? "#1890ff" : "#ccc",
                                                            transition: ".3s",
                                                            borderRadius: "24px"
                                                        }}
                                                    >
                                                        <span
                                                            style={{
                                                                position: "absolute",
                                                                content: '""',
                                                                height: "18px",
                                                                width: "18px",
                                                                left: formStatus ? "22px" : "3px",
                                                                bottom: "3px",
                                                                backgroundColor: "white",
                                                                transition: ".3s",
                                                                borderRadius: "50%"
                                                            }}
                                                        />
                                                    </span>
                                                </label>
                                            </div>
                                        </div>

                                        {/* PHẦN CẤP QUYỀN HẠN DẠNG ACCORDION THU GỌN / MỞ RỘNG */}
                                        <div style={{ borderTop: "1px solid #f0f0f0", paddingTop: "16px", marginBottom: "24px" }}>
                                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "14px", flexWrap: "wrap", gap: "10px" }}>
                                                <div>
                                                    <div style={{ fontSize: "15px", fontWeight: 700, color: "#111827" }}>
                                                        Phân quyền truy cập các mục hệ thống
                                                    </div>
                                                    <div style={{ fontSize: "12px", color: "#6b7280", marginTop: "2px" }}>
                                                        Bấm vào từng nhóm để mở rộng và tùy chỉnh chi tiết từng mục con
                                                    </div>
                                                </div>
                                                <div style={{ display: "flex", gap: "8px" }}>
                                                    <button
                                                        type="button"
                                                        onClick={() => handleExpandAll(true)}
                                                        style={{
                                                            background: "#f3f4f6",
                                                            border: "1px solid #e5e7eb",
                                                            borderRadius: "6px",
                                                            padding: "4px 10px",
                                                            fontSize: "12px",
                                                            color: "#374151",
                                                            cursor: "pointer",
                                                            fontWeight: 500
                                                        }}
                                                    >
                                                        Mở rộng tất cả ▼
                                                    </button>
                                                    <button
                                                        type="button"
                                                        onClick={() => handleExpandAll(false)}
                                                        style={{
                                                            background: "#f3f4f6",
                                                            border: "1px solid #e5e7eb",
                                                            borderRadius: "6px",
                                                            padding: "4px 10px",
                                                            fontSize: "12px",
                                                            color: "#374151",
                                                            cursor: "pointer",
                                                            fontWeight: 500
                                                        }}
                                                    >
                                                        Thu gọn tất cả ▲
                                                    </button>
                                                </div>
                                            </div>

                                            {/* Master Roles: Toàn quyền & Chỉ xem */}
                                            <div className="happy-adminlist-modal-master-roles" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "14px", marginBottom: "16px" }}>
                                                {/* Full Admin */}
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "space-between",
                                                        padding: "10px 14px",
                                                        borderRadius: "8px",
                                                        background: permState.full ? "#fef2f2" : "#f9fafb",
                                                        border: `1.5px solid ${permState.full ? "#ef4444" : "#e5e7eb"}`,
                                                        boxShadow: permState.full ? "0 2px 6px rgba(239, 68, 68, 0.12)" : "none",
                                                        transition: "all .2s"
                                                    }}
                                                >
                                                    <div>
                                                        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                                            <AdminPanelSettingsIcon style={{ fontSize: "19px", color: permState.full ? "#dc2626" : "#64748b" }} />
                                                            <span style={{ fontSize: "13.5px", fontWeight: 700, color: permState.full ? "#dc2626" : "#1f2937" }}>
                                                                Toàn quyền Admin (Full)
                                                            </span>
                                                        </div>
                                                        <div style={{ fontSize: "11.5px", color: "#6b7280", marginTop: "2px" }}>
                                                            Bật toàn bộ quyền thao tác & quản trị hệ thống
                                                        </div>
                                                    </div>
                                                    <label style={{ position: "relative", display: "inline-block", width: "40px", height: "22px", flexShrink: 0, marginLeft: "10px" }}>
                                                        <input
                                                            type="checkbox"
                                                            disabled={isCurrentReadOnly}
                                                            checked={!!permState.full}
                                                            onChange={(e) => {
                                                                if (isCurrentReadOnly) return;
                                                                handleToggleFullAdmin(e.target.checked);
                                                            }}
                                                            style={{ opacity: 0, width: 0, height: 0 }}
                                                        />
                                                        <span
                                                            style={{
                                                                position: "absolute",
                                                                cursor: "pointer",
                                                                top: 0,
                                                                left: 0,
                                                                right: 0,
                                                                bottom: 0,
                                                                backgroundColor: permState.full ? "#dc2626" : "#ccc",
                                                                transition: ".3s",
                                                                borderRadius: "22px"
                                                            }}
                                                        >
                                                            <span
                                                                style={{
                                                                    position: "absolute",
                                                                    content: '""',
                                                                    height: "16px",
                                                                    width: "16px",
                                                                    left: permState.full ? "21px" : "3px",
                                                                    bottom: "3px",
                                                                    backgroundColor: "white",
                                                                    transition: ".3s",
                                                                    borderRadius: "50%"
                                                                }}
                                                            />
                                                        </span>
                                                    </label>
                                                </div>

                                                {/* Read-Only */}
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "space-between",
                                                        padding: "10px 14px",
                                                        borderRadius: "8px",
                                                        background: permState.readonly ? "#fff7ed" : "#f9fafb",
                                                        border: `1.5px solid ${permState.readonly ? "#f97316" : "#e5e7eb"}`,
                                                        boxShadow: permState.readonly ? "0 2px 6px rgba(249, 115, 22, 0.12)" : "none",
                                                        transition: "all .2s"
                                                    }}
                                                >
                                                    <div>
                                                        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                                            <RemoveRedEyeIcon style={{ fontSize: "19px", color: permState.readonly ? "#ea580c" : "#64748b" }} />
                                                            <span style={{ fontSize: "13.5px", fontWeight: 700, color: permState.readonly ? "#ea580c" : "#1f2937" }}>
                                                                Chế độ Chỉ xem (Read-only)
                                                            </span>
                                                        </div>
                                                        <div style={{ fontSize: "11.5px", color: "#6b7280", marginTop: "2px" }}>
                                                            Khóa tất cả nút Thêm, Sửa, Xóa, Khóa, Phê duyệt
                                                        </div>
                                                    </div>
                                                    <label style={{ position: "relative", display: "inline-block", width: "40px", height: "22px", flexShrink: 0, marginLeft: "10px" }}>
                                                        <input
                                                            type="checkbox"
                                                            disabled={isCurrentReadOnly}
                                                            checked={!!permState.readonly}
                                                            onChange={(e) => {
                                                                if (isCurrentReadOnly) return;
                                                                const val = e.target.checked;
                                                                const updated = { ...permState, readonly: val };
                                                                if (val) {
                                                                    updated.full = false;
                                                                }
                                                                setPermState(updated);
                                                            }}
                                                            style={{ opacity: 0, width: 0, height: 0 }}
                                                        />
                                                        <span
                                                            style={{
                                                                position: "absolute",
                                                                cursor: "pointer",
                                                                top: 0,
                                                                left: 0,
                                                                right: 0,
                                                                bottom: 0,
                                                                backgroundColor: permState.readonly ? "#ea580c" : "#ccc",
                                                                transition: ".3s",
                                                                borderRadius: "22px"
                                                            }}
                                                        >
                                                            <span
                                                                style={{
                                                                    position: "absolute",
                                                                    content: '""',
                                                                    height: "16px",
                                                                    width: "16px",
                                                                    left: permState.readonly ? "21px" : "3px",
                                                                    bottom: "3px",
                                                                    backgroundColor: "white",
                                                                    transition: ".3s",
                                                                    borderRadius: "50%"
                                                                }}
                                                            />
                                                        </span>
                                                    </label>
                                                </div>
                                            </div>

                                            {/* Danh sách các Nhóm Quyền dạng Accordion */}
                                            <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                                                {PERMISSION_GROUPS.map((group) => {
                                                    const enabledCount = group.children.filter((c) => !!permState[c.key]).length;
                                                    const isAllGroupChecked = enabledCount === group.children.length;
                                                    const isExpanded = !!expandedGroups[group.key];

                                                    return (
                                                        <div
                                                            key={group.key}
                                                            style={{
                                                                border: `1px solid ${isExpanded ? "#bfdbfe" : enabledCount > 0 ? "#cbd5e1" : "#e2e8f0"}`,
                                                                borderRadius: "8px",
                                                                background: "#fff",
                                                                overflow: "hidden",
                                                                boxShadow: isExpanded ? "0 2px 6px rgba(59, 130, 246, 0.08)" : "0 1px 2px rgba(0,0,0,0.02)",
                                                                transition: "all .15s"
                                                            }}
                                                        >
                                                            {/* Accordion Header */}
                                                            <div
                                                                onClick={() => toggleExpandGroup(group.key)}
                                                                style={{
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "space-between",
                                                                    padding: "10px 16px",
                                                                    background: isExpanded ? "#f0f7ff" : enabledCount > 0 ? "#f8fafc" : "#ffffff",
                                                                    cursor: "pointer",
                                                                    userSelect: "none",
                                                                    borderBottom: isExpanded ? "1px solid #e0edff" : "none",
                                                                    transition: "background .15s"
                                                                }}
                                                            >
                                                                {/* Bên trái: Mũi tên + Icon + Tên nhóm + Badge số lượng */}
                                                                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                                                    <KeyboardArrowRightIcon
                                                                        style={{
                                                                            fontSize: "19px",
                                                                            color: isExpanded ? "#1d4ed8" : "#94a3b8",
                                                                            transform: isExpanded ? "rotate(90deg)" : "rotate(0deg)",
                                                                            transition: "transform .2s ease"
                                                                        }}
                                                                    />
                                                                    <span
                                                                        style={{
                                                                            display: "inline-flex",
                                                                            alignItems: "center",
                                                                            justifyContent: "center",
                                                                            width: "20px",
                                                                            height: "20px",
                                                                            fontSize: "18px",
                                                                            color: isExpanded ? "#1d4ed8" : "#475569"
                                                                        }}
                                                                    >
                                                                        {group.icon}
                                                                    </span>
                                                                    <span style={{ fontSize: "13.5px", fontWeight: 600, color: isExpanded ? "#1e40af" : "#1e293b" }}>
                                                                        {group.label}
                                                                    </span>
                                                                    <span
                                                                        style={{
                                                                            fontSize: "11px",
                                                                            fontWeight: 600,
                                                                            padding: "2px 8px",
                                                                            borderRadius: "12px",
                                                                            background: isAllGroupChecked ? "#e0f2fe" : enabledCount > 0 ? "#fef3c7" : "#f1f5f9",
                                                                            color: isAllGroupChecked ? "#0284c7" : enabledCount > 0 ? "#d97706" : "#64748b"
                                                                        }}
                                                                    >
                                                                        {isAllGroupChecked
                                                                            ? `Đầy đủ (${enabledCount}/${group.children.length})`
                                                                            : enabledCount > 0
                                                                            ? `Đã chọn ${enabledCount}/${group.children.length}`
                                                                            : `Tắt (0/${group.children.length})`}
                                                                    </span>
                                                                </div>

                                                                {/* Bên phải: Nút bật/tắt cả nhóm */}
                                                                <div
                                                                    onClick={(e) => e.stopPropagation()}
                                                                    style={{ display: "flex", alignItems: "center", gap: "8px" }}
                                                                >
                                                                    <span style={{ fontSize: "12px", color: "#64748b" }}>
                                                                        {isAllGroupChecked ? "Đang bật" : "Bật nhóm"}
                                                                    </span>
                                                                    <label style={{ position: "relative", display: "inline-block", width: "36px", height: "20px" }}>
                                                                        <input
                                                                            type="checkbox"
                                                                            disabled={isCurrentReadOnly}
                                                                            checked={isAllGroupChecked}
                                                                            onChange={(e) => {
                                                                                if (isCurrentReadOnly) return;
                                                                                handleToggleGroup(group, e.target.checked);
                                                                            }}
                                                                            style={{ opacity: 0, width: 0, height: 0 }}
                                                                        />
                                                                        <span
                                                                            style={{
                                                                                position: "absolute",
                                                                                cursor: "pointer",
                                                                                top: 0,
                                                                                left: 0,
                                                                                right: 0,
                                                                                bottom: 0,
                                                                                backgroundColor: isAllGroupChecked ? "#1890ff" : enabledCount > 0 ? "#93c5fd" : "#cbd5e1",
                                                                                transition: ".3s",
                                                                                borderRadius: "20px"
                                                                            }}
                                                                        >
                                                                            <span
                                                                                style={{
                                                                                    position: "absolute",
                                                                                    content: '""',
                                                                                    height: "14px",
                                                                                    width: "14px",
                                                                                    left: isAllGroupChecked ? "19px" : "3px",
                                                                                    bottom: "3px",
                                                                                    backgroundColor: "white",
                                                                                    transition: ".3s",
                                                                                    borderRadius: "50%"
                                                                                }}
                                                                            />
                                                                        </span>
                                                                    </label>
                                                                </div>
                                                            </div>

                                                            {/* Accordion Body: Chỉ hiện ra khi người dùng bấm vào nhóm */}
                                                            {isExpanded && (
                                                                <div
                                                                    className="happy-adminlist-perm-children"
                                                                    style={{
                                                                        padding: "12px 16px",
                                                                        background: "#f8fafc",
                                                                        display: "grid",
                                                                        gridTemplateColumns: "repeat(auto-fill, minmax(210px, 1fr))",
                                                                        gap: "8px 12px"
                                                                    }}
                                                                >
                                                                    {group.children.map((child) => {
                                                                        const isChecked = !!permState[child.key];
                                                                        return (
                                                                            <label
                                                                                key={child.key}
                                                                                style={{
                                                                                    display: "flex",
                                                                                    alignItems: "center",
                                                                                    gap: "8px",
                                                                                    padding: "8px 12px",
                                                                                    borderRadius: "6px",
                                                                                    background: isChecked ? "#ffffff" : "#f1f5f9",
                                                                                    border: `1px solid ${isChecked ? "#93c5fd" : "#e2e8f0"}`,
                                                                                    cursor: isCurrentReadOnly ? "default" : "pointer",
                                                                                    userSelect: "none",
                                                                                    transition: "all .15s"
                                                                                }}
                                                                            >
                                                                                <input
                                                                                    type="checkbox"
                                                                                    disabled={isCurrentReadOnly}
                                                                                    checked={isChecked}
                                                                                    onChange={(e) => {
                                                                                        if (isCurrentReadOnly) return;
                                                                                        const val = e.target.checked;
                                                                                        const updated = { ...permState, [child.key]: val };
                                                                                        if (!val) {
                                                                                            updated.full = false;
                                                                                        }
                                                                                        setPermState(updated);
                                                                                    }}
                                                                                    style={{
                                                                                        width: "16px",
                                                                                        height: "16px",
                                                                                        accentColor: "#1890ff",
                                                                                        cursor: isCurrentReadOnly ? "default" : "pointer"
                                                                                    }}
                                                                                />
                                                                                <div style={{ flexGrow: 1, minWidth: 0 }}>
                                                                                    <div
                                                                                        style={{
                                                                                            fontSize: "12.5px",
                                                                                            fontWeight: isChecked ? 600 : 400,
                                                                                            color: isChecked ? "#1e40af" : "#334155"
                                                                                        }}
                                                                                    >
                                                                                        {child.label}
                                                                                    </div>
                                                                                    {child.desc && (
                                                                                        <div
                                                                                            style={{
                                                                                                fontSize: "11px",
                                                                                                color: "#94a3b8",
                                                                                                marginTop: "1px",
                                                                                                whiteSpace: "nowrap",
                                                                                                overflow: "hidden",
                                                                                                textOverflow: "ellipsis"
                                                                                            }}
                                                                                        >
                                                                                            {child.desc}
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                            </label>
                                                                        );
                                                                    })}
                                                                </div>
                                                            )}
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>

                                        {/* Nút hành động Modal (Matching Image 3) */}
                                        <div className="happy-adminlist-modal-actions" style={{ display: "flex", gap: "12px", marginTop: "24px", alignItems: "center" }}>
                                            {!isCurrentReadOnly && (
                                                <button
                                                    type="submit"
                                                    style={{
                                                        background: "#d9534f",
                                                        border: "none",
                                                        borderRadius: "6px",
                                                        padding: "8px 24px",
                                                        fontSize: "14px",
                                                        color: "#fff",
                                                        fontWeight: 500,
                                                        cursor: "pointer"
                                                    }}
                                                >
                                                    {modalMode === "create" ? "Thêm mới" : "Cập nhật"}
                                                </button>
                                            )}
                                            <button
                                                type="button"
                                                onClick={() => setIsModalOpen(false)}
                                                style={{
                                                    background: "#fff",
                                                    border: "1px solid #d9d9d9",
                                                    borderRadius: "6px",
                                                    padding: "8px 20px",
                                                    fontSize: "14px",
                                                    color: "#555",
                                                    cursor: "pointer"
                                                }}
                                            >
                                                {isCurrentReadOnly ? "Đóng" : "Hủy bỏ"}
                                            </button>

                                            {modalMode === "edit" && !isCurrentReadOnly && selectedItem && selectedItem.username !== "superadmin" && selectedItem.username !== profile?.username && (
                                                <button
                                                    type="button"
                                                    onClick={() => handleDeleteEmployee(selectedItem)}
                                                    style={{
                                                        marginLeft: "auto",
                                                        background: "#fff",
                                                        border: "1px solid #fecaca",
                                                        borderRadius: "6px",
                                                        padding: "8px 16px",
                                                        fontSize: "13px",
                                                        color: "#dc2626",
                                                        fontWeight: 500,
                                                        cursor: "pointer",
                                                        display: "inline-flex",
                                                        alignItems: "center",
                                                        gap: "6px"
                                                    }}
                                                >
                                                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                        <polyline points="3 6 5 6 21 6" />
                                                        <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
                                                        <line x1="10" y1="11" x2="10" y2="17" />
                                                        <line x1="14" y1="11" x2="14" y2="17" />
                                                    </svg>
                                                    Xóa nhân viên này
                                                </button>
                                            )}
                                        </div>
                                    </form>
                                </div>
                            </div>
                        )}

                        {/* MODAL HƯỚNG DẪN CHI TIẾT */}
                        {openGuideModal && (
                            <div className="ax-modal-overlay" onClick={() => setOpenGuideModal(false)} style={{ zIndex: 12000 }}>
                                <div className="ax-modal-card" onClick={(e) => e.stopPropagation()} style={{ background: "#ffffff", maxWidth: "660px", borderRadius: "12px", boxShadow: "0 20px 40px rgba(0,0,0,0.3)" }}>
                                    <div className="ax-modal-header" style={{ display: "flex", alignItems: "center", justifyContent: "center", position: "relative", padding: "18px 24px", borderBottom: "1px solid #f0f0f0" }}>
                                        <h3 style={{ margin: 0, fontSize: "17px", fontWeight: "700", color: "#111827", textAlign: "center", flexGrow: 1 }}>
                                            Hướng dẫn chi tiết - Quản lý nhân viên & Phân quyền
                                        </h3>
                                        <span className="close-icon" style={{ position: "absolute", right: "20px", top: "50%", transform: "translateY(-50%)", fontSize: "18px", color: "#6b7280", cursor: "pointer" }} onClick={() => setOpenGuideModal(false)}>✕</span>
                                    </div>
                                    <div className="ax-modal-body" style={{ padding: "24px 28px", maxHeight: "72vh", overflowY: "auto", fontSize: "14px", color: "#374151", textAlign: "left" }}>
                                        <div style={{ marginBottom: "18px", textAlign: "left" }}>
                                            <h4 style={{ margin: "0 0 6px 0", fontSize: "15px", fontWeight: "700", color: "#111827", textAlign: "left" }}>1. Tìm kiếm & Thêm mới nhân viên</h4>
                                            <ul style={{ margin: 0, paddingLeft: "20px", listStyleType: "disc", color: "#374151", lineHeight: "1.6", textAlign: "left" }}>
                                                <li style={{ textAlign: "left" }}><b>Tìm kiếm:</b> Lọc nhanh danh sách nhân viên theo Tên đăng nhập, Địa chỉ IP hoặc Người tạo.</li>
                                                <li style={{ textAlign: "left" }}><b>Thêm mới:</b> Nhấn nút "Thêm mới" màu xanh lá để tạo tài khoản nhân viên mới, nhập mật khẩu và phân quyền tương ứng.</li>
                                            </ul>
                                        </div>

                                        <div style={{ marginBottom: "18px", textAlign: "left" }}>
                                            <h4 style={{ margin: "0 0 6px 0", fontSize: "15px", fontWeight: "700", color: "#111827", textAlign: "left" }}>2. Các nút thao tác với nhân viên</h4>
                                            <ul style={{ margin: 0, paddingLeft: "20px", listStyleType: "disc", color: "#374151", lineHeight: "1.6", textAlign: "left" }}>
                                                <li style={{ textAlign: "left" }}><b>Xem / Chỉnh sửa (Nút xanh dương):</b> Mở cửa sổ cập nhật thông tin tài khoản, đặt lại mật khẩu mới hoặc tinh chỉnh danh sách quyền truy cập.</li>
                                                <li style={{ textAlign: "left" }}><b>Khóa / Mở khóa (Nút đỏ / xanh lá):</b> Tạm thời khóa tài khoản nhân viên khi không muốn cho phép đăng nhập mà vẫn giữ nguyên dữ liệu và lịch sử. Bấm lần nữa để mở khóa ngay lập tức.</li>
                                                <li style={{ textAlign: "left" }}><b>Xóa nhân viên (Nút thùng rác đỏ):</b> Xóa vĩnh viễn tài khoản nhân viên khỏi hệ thống sau khi đã xác nhận cảnh báo an toàn.</li>
                                                <li style={{ textAlign: "left" }}><i>Lưu ý an toàn:</i> Tài khoản Quản trị cấp cao (superadmin) và tài khoản đang đăng nhập hiện tại không thể tự khóa hoặc tự xóa.</li>
                                            </ul>
                                        </div>

                                        <div style={{ marginBottom: "18px", textAlign: "left" }}>
                                            <h4 style={{ margin: "0 0 6px 0", fontSize: "15px", fontWeight: "700", color: "#111827", textAlign: "left" }}>3. Phân quyền truy cập menu chi tiết (Tree RBAC)</h4>
                                            <ul style={{ margin: 0, paddingLeft: "20px", listStyleType: "disc", color: "#374151", lineHeight: "1.6", textAlign: "left" }}>
                                                <li style={{ textAlign: "left" }}><b>Cấp quyền theo từng mục con:</b> Cho phép tùy chỉnh bật hoặc ẩn riêng từng mục cụ thể trong nhóm (ví dụ: trong Quản lý trang có thể bật Tin tức và Cài đặt trang nhưng ẩn Quản lý Banner, Điều khoản...).</li>
                                                <li style={{ textAlign: "left" }}><b>Bật/Tắt cả nhóm:</b> Dùng công tắc ở góc phải đầu mỗi nhóm để bật hoặc tắt nhanh toàn bộ các mục thuộc nhóm đó.</li>
                                                <li style={{ textAlign: "left" }}><b>Toàn quyền Admin (Full):</b> Tự động cấp toàn bộ quyền truy cập tất cả các mục hệ thống.</li>
                                                <li style={{ textAlign: "left" }}><b>Chế độ Chỉ xem (Read-only):</b> Khi bật chế độ này, nhân viên chỉ có thể xem dữ liệu và tra cứu báo cáo, toàn bộ các nút thao tác (Thêm, Sửa, Xóa, Khóa, Phê duyệt...) đều sẽ bị vô hiệu hóa để bảo đảm an toàn dữ liệu.</li>
                                            </ul>
                                        </div>

                                        <div style={{ textAlign: "left" }}>
                                            <h4 style={{ margin: "0 0 6px 0", fontSize: "15px", fontWeight: "700", color: "#111827", textAlign: "left" }}>4. Hiển thị Menu Sidebar</h4>
                                            <ul style={{ margin: 0, paddingLeft: "20px", listStyleType: "disc", color: "#374151", lineHeight: "1.6", textAlign: "left" }}>
                                                <li style={{ textAlign: "left" }}>Khi nhân viên đăng nhập, menu bên trái (Sidebar) sẽ tự động ẩn các mục mà nhân viên không được cấp quyền. Nếu một nhóm lớn không có mục con nào được cấp, cả nhóm đó cũng sẽ tự động ẩn đi.</li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="ax-modal-footer" style={{ padding: "14px 24px", borderTop: "1px solid #f0f0f0", display: "flex", justifyContent: "flex-end" }}>
                                        <button className="ax-btn-modal-close" style={{ backgroundColor: "#d9534f", color: "#fff", border: "none", padding: "8px 24px", borderRadius: "6px", fontWeight: "600", fontSize: "14px", cursor: "pointer" }} onClick={() => setOpenGuideModal(false)}>
                                            Đã hiểu
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}
                    </Box>
                ) : (
                    <Box sx={{ p: 3 }}>{t("not_permission")}</Box>
                )}
            </DashboardLayout>
        </ThemeProvider>
    );
}

export default AdminList;
